export default __webpack_public_path__ + "static/media/timeline-2.ac568e3e.png";